var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"title":_vm.title|| _vm.$t('loginButton')},nativeOn:{"click":function($event){return _vm.login.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }